import * as React from "react";

// Stores
import { ActivityStore } from "stores";

// Layout
import { Divider, Grid } from "@material-ui/core";
import { Observer } from "mobx-react-lite";
import {
    CardTypeButtons,
    FontSizeButtons,
    worksheetOptionsBackgroundStyle,
} from "components/activities/CommonActivityOptions";
import { CardType } from "models/customLists/CategoryItem";
import SimpleCheckbox from "components/SimpleCheckbox";
import { strings } from "core/localizedStrings";
import { NumberOfWorksheetColumns } from "../WorksheetHelper";
import { WorksheetOptions } from "../WorksheetScene";

export interface TracingWorksheetOptions extends WorksheetOptions {
    cardType: CardType;
    isTraceable: boolean;
    numberOfColumns: NumberOfWorksheetColumns;
    fontSize: number;
}

export const defaultTracingWorksheetOptions: TracingWorksheetOptions = {
    cardType: CardType.IMAGE_ONLY,
    isTraceable: true,
    numberOfColumns: NumberOfWorksheetColumns.ONE,
    fontSize: 140,
};

interface TracingWorksheetOptionsProps extends React.Props<any> {
    activityStore: ActivityStore;
}

const TracingWorksheetOptions = (props: TracingWorksheetOptionsProps) => {
    const handleCardTypeChanged = (cardType: CardType) => {
        props.activityStore.activityOptions.tracingWorksheetOptions.cardType = cardType;
        props.activityStore.updateOptions();
    };

    const handleTwoColumnsCheckboxChanged = (value: boolean) => {
        props.activityStore.activityOptions.tracingWorksheetOptions.numberOfColumns = value
            ? NumberOfWorksheetColumns.TWO
            : NumberOfWorksheetColumns.ONE;
        props.activityStore.updateOptions();
    };

    const handleTraceableCheckboxChanged = (value: boolean) => {
        props.activityStore.activityOptions.tracingWorksheetOptions.isTraceable = value;
        props.activityStore.updateOptions();
    };

    const handleFontSizeDecremented = () => {
        const MIN_FONT_SIZE = 80;
        props.activityStore.activityOptions.tracingWorksheetOptions.fontSize *= 0.8;
        if (props.activityStore.activityOptions.tracingWorksheetOptions.fontSize < MIN_FONT_SIZE) {
            props.activityStore.activityOptions.tracingWorksheetOptions.fontSize = MIN_FONT_SIZE;
        }
    };

    const handleFontSizeIncremented = () => {
        const MAX_FONT_SIZE = 200;
        props.activityStore.activityOptions.tracingWorksheetOptions.fontSize *= 1.2;
        if (props.activityStore.activityOptions.tracingWorksheetOptions.fontSize > MAX_FONT_SIZE) {
            props.activityStore.activityOptions.tracingWorksheetOptions.fontSize = MAX_FONT_SIZE;
        }
    };

    return (
        <Observer
            render={() => (
                <>
                    <CardTypeButtons activityStore={props.activityStore} onCardTypeChanged={handleCardTypeChanged} />
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        style={worksheetOptionsBackgroundStyle}
                    >
                        <Grid container justify="center">
                            <Grid item>
                                <SimpleCheckbox
                                    label={strings.twoColumns}
                                    isChecked={
                                        props.activityStore.activityOptions.tracingWorksheetOptions.numberOfColumns ===
                                        NumberOfWorksheetColumns.TWO
                                    }
                                    onChange={handleTwoColumnsCheckboxChanged}
                                />
                            </Grid>
                            <Grid item>
                                <SimpleCheckbox
                                    label={strings.isTraceable}
                                    isChecked={props.activityStore.activityOptions.tracingWorksheetOptions.isTraceable}
                                    onChange={handleTraceableCheckboxChanged}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <FontSizeButtons
                        onFontSizeDecremented={handleFontSizeDecremented}
                        onFontSizeIncremented={handleFontSizeIncremented}
                    />
                </>
            )}
        />
    );
};

export default TracingWorksheetOptions;
